import { render, staticRenderFns } from "./MenuSetting.vue?vue&type=template&id=6da1e628&scoped=true&"
import script from "./MenuSetting.vue?vue&type=script&lang=js&"
export * from "./MenuSetting.vue?vue&type=script&lang=js&"
import style0 from "./MenuSetting.vue?vue&type=style&index=0&id=6da1e628&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da1e628",
  null
  
)

export default component.exports